"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _joiBrowser = _interopRequireDefault(require("joi-browser"));

var _HttpService = _interopRequireDefault(require("../HttpService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var minNameLength = 2;

var TenantService = /*#__PURE__*/function () {
  function TenantService() {
    _classCallCheck(this, TenantService);
  }

  _createClass(TenantService, null, [{
    key: "normalizeName",
    value: function normalizeName(displayName) {
      if (!displayName) {
        return displayName;
      }

      return displayName.toLowerCase().trim().replace(/[^\w\s-]|_/gi, '').replace(/\s+/g, '-');
    }
  }, {
    key: "getTenantUrl",
    value: function getTenantUrl(name) {
      return "".concat(window.location.protocol, "//").concat(TenantService.normalizeName(name), ".").concat(env.REACT_APP_DOMAIN);
    }
  }, {
    key: "getTenants",
    value: function getTenants() {
      return this.httpService.get('/');
    }
  }, {
    key: "isDisplayNameValid",
    value: function isDisplayNameValid(displayName) {
      return displayName.length >= minNameLength;
    }
  }, {
    key: "isNameValid",
    value: function isNameValid(name) {
      return name !== undefined && name !== null && name.length >= minNameLength && !name.match(/^-|-$/);
    }
  }, {
    key: "isTenantUserRequestValid",
    value: function isTenantUserRequestValid(tenantUserRequest) {
      if (tenantUserRequest === null || tenantUserRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        auth0UserId: _joiBrowser["default"].string().required(),
        email: _joiBrowser["default"].string().email().required(),
        firstName: _joiBrowser["default"].string().allow(''),
        lastName: _joiBrowser["default"].string().allow(''),
        passive: _joiBrowser["default"]["boolean"]()
      });

      return _joiBrowser["default"].validate(tenantUserRequest, schema).error === null;
    }
  }, {
    key: "isUpdateTenantUserRequestValid",
    value: function isUpdateTenantUserRequestValid(updateTenantUserRequest) {
      if (updateTenantUserRequest === null || updateTenantUserRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        email: _joiBrowser["default"].string().email(),
        firstName: _joiBrowser["default"].string().allow(''),
        lastName: _joiBrowser["default"].string().allow(''),
        phone: _joiBrowser["default"].string().allow(''),
        roles: _joiBrowser["default"].array().items(_joiBrowser["default"].string()),
        passive: _joiBrowser["default"]["boolean"]().allow(null).optional()
      });

      return _joiBrowser["default"].validate(updateTenantUserRequest, schema).error === null;
    }
  }, {
    key: "isTenantUsersValid",
    value: function isTenantUsersValid(tenantUsers) {
      if (tenantUsers === null || tenantUsers === undefined || tenantUsers.length === 0) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        email: _joiBrowser["default"].string().email().required(),
        firstName: _joiBrowser["default"].string().allow(''),
        lastName: _joiBrowser["default"].string().allow(''),
        phone: _joiBrowser["default"].string().allow(''),
        passive: _joiBrowser["default"]["boolean"]()
      });

      return _joiBrowser["default"].validate(tenantUsers[0], schema).error === null;
    }
  }, {
    key: "getTenantValidationError",
    value: function getTenantValidationError(tenant) {
      if (!tenant) {
        return new Error('Tenant missing');
      }

      if (!TenantService.isDisplayNameValid(tenant.displayName)) {
        return new Error('Tenant display name missing');
      }

      if (!TenantService.isNameValid(tenant.name)) {
        return new Error('Tenant name missing');
      }

      return undefined;
    }
  }, {
    key: "addTenant",
    value: function addTenant(tenant) {
      var _this = this;

      var error = TenantService.getTenantValidationError(tenant);

      if (error) {
        return Promise.reject(error);
      }

      return new Promise(function (resolve, reject) {
        _this.httpService.post('/', tenant).then(function (response) {
          global.window.localStorage.removeItem('profile_expiration');
          resolve(response);
        }, function (errorResponse) {
          return reject(new Error(errorResponse.data.message));
        });
      });
    }
  }, {
    key: "getTenant",
    value: function getTenant(name) {
      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      return this.httpService.get("/".concat(name));
    }
  }, {
    key: "getTenantCard",
    value: function getTenantCard(name, cardId) {
      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      return this.httpService.get("/".concat(name, "/cards/").concat(cardId));
    }
  }, {
    key: "getTenantInvoices",
    value: function getTenantInvoices(name) {
      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      return this.httpService.get("/".concat(name, "/invoices"));
    }
  }, {
    key: "getTenantUpcomingInvoice",
    value: function getTenantUpcomingInvoice(name) {
      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      return this.httpService.get("/".concat(name, "/upcomingInvoices"));
    }
  }, {
    key: "getTenantPreviewInvoice",
    value: function getTenantPreviewInvoice(name, newStripePlan, newUserLimit) {
      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      return this.httpService.get("/".concat(name, "/previewInvoice/").concat(newStripePlan, "/userLimit/").concat(newUserLimit));
    }
  }, {
    key: "updateTenant",
    value: function updateTenant(tenant) {
      var _this2 = this;

      var error = TenantService.getTenantValidationError(tenant);

      if (error) {
        return Promise.reject(error);
      }

      return new Promise(function (resolve, reject) {
        _this2.httpService.patch("/".concat(tenant.name), tenant).then(function (response) {
          if (tenant.icon !== null) {
            /*
              Since the CDN takes a few seconds to invalidate objects, we will set the
              updated icon string so the user sees the updates on response and not the
              old cache icon from the CDN url
            */
            response.avatar = tenant.icon;
          }

          resolve(response);
        }, function (errorResponse) {
          return reject(new Error(errorResponse.data.message));
        });
      });
    }
  }, {
    key: "updateTenantCompletedOnboardingSteps",
    value: function updateTenantCompletedOnboardingSteps(tenantName, request) {
      var _this3 = this;

      if (!TenantService.isNameValid(tenantName)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      return new Promise(function (resolve, reject) {
        _this3.httpService.patch("/".concat(tenantName, "/onboardingSteps"), request).then(function (response) {
          resolve(response);
        }, function (errorResponse) {
          return reject(new Error(errorResponse.data.message));
        });
      });
    }
  }, {
    key: "getTenantUserRequests",
    value: function getTenantUserRequests(name) {
      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      return this.httpService.get("/".concat(name, "/tenantUserRequests"));
    }
  }, {
    key: "addTenantUserRequest",
    value: function addTenantUserRequest(name, tenantUserRequest) {
      var _this4 = this;

      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      if (!TenantService.isTenantUserRequestValid(tenantUserRequest)) {
        return Promise.reject(new Error('Invalid tenant user request'));
      }

      return new Promise(function (resolve, reject) {
        _this4.httpService.post("/".concat(name, "/tenantUserRequests"), tenantUserRequest).then(function (response) {
          if (response.status === '208') {
            return reject(new Error(response.message));
          }

          return resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "getTenantUsers",
    value: function getTenantUsers(name) {
      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      return this.httpService.get("/".concat(name, "/users"));
    }
  }, {
    key: "getTenantUser",
    value: function getTenantUser(name, auth0UserId) {
      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      if (!TenantService.isNameValid(auth0UserId)) {
        return Promise.reject(new Error('Invalid User ID'));
      }

      return this.httpService.get("/".concat(name, "/users/").concat(auth0UserId));
    }
  }, {
    key: "addTenantUsers",
    value: function addTenantUsers(name, tenantUsers) {
      var _this5 = this;

      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      if (!TenantService.isTenantUsersValid(tenantUsers)) {
        return Promise.reject(new Error('Invalid add tenant users request'));
      }

      return new Promise(function (resolve, reject) {
        _this5.httpService.post("/".concat(name, "/users"), tenantUsers).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "removeUserFromTenant",
    value: function removeUserFromTenant(name, auth0UserId) {
      var _this6 = this;

      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      if (!TenantService.isNameValid(auth0UserId)) {
        return Promise.reject(new Error('Invalid User ID'));
      }

      return new Promise(function (resolve, reject) {
        _this6.httpService["delete"]("/".concat(name, "/users/").concat(auth0UserId)).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "updateTenantUser",
    value: function updateTenantUser(name, auth0UserId, updateTenantUserRequest) {
      var _this7 = this;

      if (!TenantService.isNameValid(name)) {
        return Promise.reject(new Error('Tenant name missing'));
      }

      if (!TenantService.isNameValid(auth0UserId)) {
        return Promise.reject(new Error('Invalid User ID'));
      }

      if (!TenantService.isUpdateTenantUserRequestValid(updateTenantUserRequest)) {
        return Promise.reject(new Error('Invalid update tenant user request'));
      }

      return new Promise(function (resolve, reject) {
        _this7.httpService.patch("/".concat(name, "/users/").concat(auth0UserId), updateTenantUserRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }]);

  return TenantService;
}();

exports["default"] = TenantService;
TenantService.httpService = new _HttpService["default"]({
  baseURL: "".concat(typeof window !== 'undefined' ? env.REACT_APP_TENANT_API : '', "/tenants")
});